export const routes = (prefix = `claims`) => [
    {
        path: `/${prefix}/raise`,
        name: `${prefix}.raise.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.raise.index`,
                PageDescription: "Claims: Raise claims",
            },
        },
    },
];
